import { memo } from 'react';
import {
  TreeItemRoot,
  TreeItemCaret,
  TreeItemCheckbox,
  TreeItemIcon,
  TreeItemLabel,
  TreeItemEnd,
  TreeItemBadge,
} from './TreeItemCompound';
import type { TreeItemProps } from './TreeItem.types';

export type { TreeItemLevel, TreeItemProps, TreeItemVariant, TreeItemRootProps } from './TreeItem.types';
export type { TreeItemExpansionProps, TreeItemPresentationProps, TreeItemSelectionProps } from './TreeItem.types';
export type { TreeItemContextValue } from './TreeItemContext';
export { useTreeItemContext } from './TreeItemContext';
export { useTreeItemRowState } from './useTreeItemRowState';
export type { UseTreeItemRowStateParams } from './useTreeItemRowState';

function TreeItemDefaultLayout(props: TreeItemProps) {
  return (
    <TreeItemRoot {...props}>
      <TreeItemCaret />
      <TreeItemCheckbox />
      <TreeItemIcon />
      <TreeItemLabel />
      <TreeItemEnd />
      <TreeItemBadge />
    </TreeItemRoot>
  );
}

const TreeItemMemo = memo(TreeItemDefaultLayout);
TreeItemMemo.displayName = 'TreeItem';

export type TreeItemCompoundStatic = {
  Root: typeof TreeItemRoot;
  Caret: typeof TreeItemCaret;
  Checkbox: typeof TreeItemCheckbox;
  Icon: typeof TreeItemIcon;
  Label: typeof TreeItemLabel;
  End: typeof TreeItemEnd;
  Badge: typeof TreeItemBadge;
};

export type TreeItemComponent = typeof TreeItemMemo & TreeItemCompoundStatic;

const TreeItem: TreeItemComponent = Object.assign(TreeItemMemo, {
  Root: TreeItemRoot,
  Caret: TreeItemCaret,
  Checkbox: TreeItemCheckbox,
  Icon: TreeItemIcon,
  Label: TreeItemLabel,
  End: TreeItemEnd,
  Badge: TreeItemBadge,
});

export default TreeItem;
